import React from "react";
import { Heart, Leaf, Stars, Crown } from "lucide-react";
import { SALON } from "../data/salonData";

const HIGHLIGHTS = [
  { icon: Crown, label: "Experienced beauticians" },
  { icon: Stars, label: "Premium beauty products" },
  { icon: Leaf, label: "Affordable luxury pricing" },
  { icon: Heart, label: "Friendly, personalised care" },
];

export const About = () => {
  return (
    <section
      id="about"
      data-testid="about-section"
      className="relative py-24 sm:py-28 px-5 sm:px-8 lg:px-12 max-w-5xl mx-auto"
    >
      <div className="text-center reveal">
        <span className="label-eyebrow">About the salon</span>
        <h2 className="mt-3 font-display text-3xl sm:text-4xl lg:text-5xl leading-tight tracking-tight text-luxuryBlack">
          Where beauty begins with{" "}
          <span className="hero-script">confidence</span>.
        </h2>
        <p className="mt-6 text-base sm:text-lg text-luxuryBlack/70 leading-relaxed max-w-2xl mx-auto">
          At <strong className="text-luxuryBlack">Kinjal&rsquo;s Beauty &amp; Hair</strong>,
          we believe true beauty starts with how you feel. We provide
          affordable luxury beauty services with professional care in a
          relaxing, hygienic environment — from precise threading and
          silky-smooth waxing to indulgent premium facials and salon-grade
          hair rituals.
        </p>
      </div>

      <div className="mt-12 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 reveal">
        {HIGHLIGHTS.map(({ icon: Icon, label }) => (
          <div
            key={label}
            data-testid={`about-highlight-${label.replace(/\s+/g, "-").toLowerCase()}`}
            className="glass-card rounded-2xl p-5 flex flex-col items-center text-center gap-3 hover:-translate-y-1 transition-transform duration-300"
          >
            <div className="w-12 h-12 rounded-full bg-roseGoldDeep flex items-center justify-center">
              <Icon className="w-5 h-5 text-white" />
            </div>
            <span className="text-sm sm:text-base font-medium text-luxuryBlack">
              {label}
            </span>
          </div>
        ))}
      </div>

      <div className="mt-12 flex flex-wrap items-center justify-center gap-4 reveal">
        <a href="#services" data-testid="about-services-cta" className="btn-rose">
          Explore Services
        </a>
        <a href={`tel:${SALON.phoneTel}`} data-testid="about-call-cta" className="btn-outline">
          Call Us
        </a>
      </div>
    </section>
  );
};

export default About;
